<div class="form-group mb-20">
    <label class="control-label col-xs-9">
        {{ "control_animation_on_scroll" | translate }}
        @if (isDisabled()) {
            <span
                class="small sp-icon icon-question color-light hover-effect"
                [tooltip]="'animation_disabled_tooltip' | translate"
                [placement]="'top'"
                [adaptivePosition]="true"
                triggers="mouseover:mouseleave"
            ></span>
        }
    </label>
    <div class="col-xs-3 control-switch text-right" [class.disabled]="isDisabled()">
        <sp-switch [active]="isActive()" (toggleActiveEvent)="toggleActive($event)"></sp-switch>
    </div>
</div>

@if (isActive()) {
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_type" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" (change)="onTypeChange($event)">
                <option [value]="EAnimationType.fade" [selected]="animationType() === EAnimationType.fade">
                    {{ "option_animation_type_fade" | translate }}
                </option>
                <option [value]="EAnimationType.scale" [selected]="animationType() === EAnimationType.scale">
                    {{ "option_animation_type_scale" | translate }}
                </option>
                <option [value]="EAnimationType.slide" [selected]="animationType() === EAnimationType.slide">
                    {{ "option_animation_type_slide" | translate }}
                </option>
                @if (showRunningStripe()) {
                    <option [value]="EAnimationType.runningStripe" [selected]="isRunningStripe()">
                        {{ "option_animation_type_running_stripe" | translate }}
                    </option>
                }
            </select>

            @if (isRunningStripe()) {
                <div class="alert alert-info-mutted alert-sm mb-0 mt-10">
                    {{ "alert_running_stripe_animation" | translate }}
                </div>
            }
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_position" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" (change)="onPositionChange($event)">
                <option [value]="EAnimationPosition.left" [selected]="animationPosition() === EAnimationPosition.left">
                    {{ "option_animation_position_left" | translate }}
                </option>
                @if (!isRunningStripe()) {
                    <option
                        [value]="EAnimationPosition.top"
                        [selected]="animationPosition() === EAnimationPosition.top"
                    >
                        {{ "option_animation_position_top" | translate }}
                    </option>
                }
                <option
                    [value]="EAnimationPosition.right"
                    [selected]="animationPosition() === EAnimationPosition.right"
                >
                    {{ "option_animation_position_right" | translate }}
                </option>
                @if (!isRunningStripe()) {
                    <option
                        [value]="EAnimationPosition.bottom"
                        [selected]="animationPosition() === EAnimationPosition.bottom"
                    >
                        {{ "option_animation_position_bottom" | translate }}
                    </option>
                }
            </select>
        </div>
    </div>

    <div class="form-group">
        <label class="col-xs-12">
            {{ "control_animation_speed" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" (change)="onSpeedChange($event)">
                <option [value]="EAnimationSpeed.slow" [selected]="animationSpeed() === EAnimationSpeed.slow">
                    {{ "option_animation_speed_slow" | translate }}
                </option>
                <option [value]="EAnimationSpeed.medium" [selected]="animationSpeed() === EAnimationSpeed.medium">
                    {{ "option_animation_speed_medium" | translate }}
                </option>
                <option [value]="EAnimationSpeed.fast" [selected]="animationSpeed() === EAnimationSpeed.fast">
                    {{ "option_animation_speed_fast" | translate }}
                </option>
            </select>
        </div>
    </div>
}
